import { useMemo } from "react";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import AirLayout from "../../airLayout";
import SelectSubmenu from "components/SelectSubmenu";
import { useAppContext } from "context/AppContext";

type LayoutProps = {
    children: React.ReactNode;
};

const menuItems = [
    { label: "표준약관", path: "/policy/terms-conditions" },
    { label: "개인정보처리방침", path: "/policy/privacy" },
];

const PolicyLayout = ({ children }: LayoutProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;
    const { isApp } = useAppContext();
    const responsive1100 = useMediaQuery(1100);

    const activeIndex = useMemo(() => {
        // return menuItems.findIndex(item => item.path === location.pathname);

        return menuItems.findIndex(menu => {
            const paths = Array.isArray(menu.path) ? menu.path : [menu.path];
            return paths.some(pattern => matchPath(pattern, path));
        });
    }, [path]);

    return (
        <div className={`flex flex-col relative ${!isApp && "mt-[116px]"}`}>
            <AirLayout>
                {!isApp && (
                    <div className="relative mt-[50px]">
                        <div className="flex bottom-0 absolute w-full h-[50px] bg-[rgba(21,34,65,0.85)] text-white justify-center">
                            {/* 1100 이하/이상 */}
                            {responsive1100 ? (
                                <SelectSubmenu menuItems={menuItems} activeIndex={activeIndex} />
                            ) : (
                                <>
                                    {menuItems.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`responsive1100:hidden w-[200px] p-2.5 flex items-center justify-center border-l border-gray-600 text-[17px] cursor-pointer ${
                                                activeIndex === index
                                                    ? "bg-[#f4f4f4] text-[#0e0057] relative after:absolute after:bottom-[-1px] after:left-0 after:w-full after:h-[1px] after:bg-[#f4f4f4]"
                                                    : "text-white"
                                            } ${index === menuItems.length - 1 ? "border-r" : ""}`}
                                            onClick={() => {
                                                if (location.pathname === item.path) {
                                                    navigate(0);
                                                } else {
                                                    const path = item.path;
                                                    navigate(path);
                                                }
                                            }}
                                        >
                                            {item.label}
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                )}
                <div className="w-full">{children}</div>
            </AirLayout>
        </div>
    );
};

export default PolicyLayout;
